import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 86 110",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 86 110\" id=\"play\"><path d=\"M0 102.44V7.06a4 4 0 0 1 6.05-3.44l74.58 44.63a4 4 0 0 1 .2 6.74L6.24 105.75A4 4 0 0 1 0 102.44Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol